export const InventoryAction = {
  SET_INVENTORY_PRODUCTS: "SET_INVENTORY_PRODUCTS",
  SET_INVENTORY_CATEGORY: "SET_INVENTORY_CATEGORY",
  SET_INVENTORY_GODOWN: "SET_INVENTORY_GODOWN",
  SET_INVENTORY_BRANDS: "SET_INVENTORY_BRANDS",
    SET_INVENTORY_PRODUCT_INGREDIENT:"SET_INVENTORY_PRODUCT_INGREDIENT"
};
export const UtilitiesAction = {
  SET_UTILITIES_EMPLOYEE: "SET_UTILITIES_EMPLOYEE",
  SET_UTILITIES_USERS: "SET_UTILITIES_USERS",
  SET_UTILITIES_ROLES: "SET_UTILITIES_ROLES",
};
export const RestaurantAction = {
  SET_NEW_TABLE_LIST: "SET_NEW_TABLE_LIST",
  SET_NEW_TABLE_GROUP: "SET_NEW_TABLE_GROUP",
};

export const CustomerAction = {
  SET_CUSTOMER_LIST: "SET_CUSTOMER_LIST",
  SET_MEMBERSHIP: "SET_MEMBERSHIP",
  SET_DISCOUNT: "SET_DISCOUNT",
  SET_PROMOCODE: "SET_PROMOCODE",
};

export const AccountsAction = {
  SET_ACCOUNT_HEAD: "SET_ACCOUNT_HEAD",
  SET_ACCOUNT_GROUP: "SET_ACCOUNT_GROUP",
  SET_GROUP_CATEGORY: "SET_GROUP_CATEGORY",
  SET_PARTY_RATE: "SET_PARTY_RATE",
};
export const SalesPurchaseAction = {
  SALES_CHANGE_HANDLER: "SALES_CHANGE_HANDLER",
  ADD_PARTICULAR: "ADD_PARTICULAR",
  SALES_RATE_CHANGE: "SALES_RATE_CHANGE",
  REMOVE_SALES_PARTICULAR: "REMOVE_SALES_PARTICULAR",
  SALES_TOTAL_CALCULATION: "SALES_TOTAL_CALCULATION",
  SALES_SET_TO_DEFAULT: "SALES_SET_TO_DEFAULT",
};
export const StockActions = {
  STOCK_PARTICULAR: "STOCK_PARTICULAR",
  REMOVE_STOCK_PARTICULAR: "REMOVE_STOCK_PARTICULAR",
  SET_STOCK_TO_DEFAULT: "SET_STOCK_TO_DEFAULT",
  STOCK_CHANGE_HANDLER: "STOCK_CHANGE_HANDLER",
};
export const BookingAction = {
  BOOKING_CHANGE_HANDLER: "BOOKING_CHANGE_HANDLER",
  BOOKING_ADD_PARTICULAR: "BOOKING_ADD_PARTICULAR",
  REMOVE_BOOKING_PARTICULAR: "REMOVE_BOOKING_PARTICULAR",
  BOOKING_TOTAL_CALCULATION: "BOOKING_TOTAL_CALCULATION",
  BOOKING_SET_TO_DEFAULT: "BOOKING_SET_TO_DEFAULT",
};

export const DashboardAction = {
  SET_ORDER_SUMMARY: "SET_ORDER_SUMMARY",
  SET_STATISTICS: "SET_STATISTICS",
  SET_TODAYINFO: "SET_TODAYINFO",
  SET_TRANSACTIONS: "SET_TRANSACTIONS",
  SET_STOCK_UPDATE: "SET_STOCK_UPDATE",
};
